import React, { Component } from 'react';
import { Button } from '@trevor/ui-components';
import { datasourceUrlPrefix } from '@/util/helpers/ajax-helpers';
import flex from '../../css/module/flex.css';
import css from '../../css/module/billing.css';

class NewSubscriptionSuccess extends Component {
  render() {
    const refreshDatasourceGAId = 'refresh-datasource-subscription';

    return (
      <div className={`${css.container} ${css.successBackground}`}>
        <div className={`${css.inner} ${flex.column} ${flex.alignItemsCenter}`}>
          <div className={css.successLogo}>
            <img width="80" height="80" src="/img/nav-logo.png" />
          </div>
          <div
            className={`${css.titleContainer} ${flex.column} ${flex.alignItemsCenter}`}
          >
            <h1>
              <b>Subscription activated</b>
            </h1>
            <p>Thank you for upgrading! </p>
          </div>
          <Button
            size="large"
            onClick={() => window.open(datasourceUrlPrefix(), '_self')}
            id={refreshDatasourceGAId}
          >
            Refresh datasource
          </Button>
        </div>
      </div>
    );
  }
}

export default NewSubscriptionSuccess;
